"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addToWindowRef = addToWindowRef;
exports.getFromWindowRef = getFromWindowRef;
exports.hasWindowRef = hasWindowRef;
var _lodash = require("@avantia/lodash");
let win;
try {
  win = window;
} catch {
  win = undefined; // not a client environment
}

function addToWindowRef(items, condition) {
  if (win && (!condition || condition(win))) {
    _lodash.lodash.forEach(items, (val, key) => {
      win[key] = val;
    });
  }
}
function hasWindowRef() {
  return !!win;
}
function getFromWindowRef(keys) {
  if (!win) {
    return undefined;
  }
  const data = {};
  keys.forEach(key => {
    data[key] = win[key];
  });
  data.window = win;
  return data;
}